import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { BoxComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-form-description',
  templateUrl: './evaluation-form-description.component.html',
  styleUrls: ['./evaluation-form-description.component.less'],
  imports: [BoxComponent],
})
export class EvaluationFormDescriptionComponent {
  private readonly sanitizer = inject(DomSanitizer);

  protected readonly safeDescription = computed(() =>
    // eslint-disable-next-line ban/ban
    this.sanitizer.bypassSecurityTrustHtml(this.description()),
  );

  public readonly title = input<string>('');
  public readonly description = input<string>('');
}
